import { getUrl } from "aws-amplify/storage";
import React, { useEffect, useState } from "react";


export default ({ filename, style }) => {
    const [uri, setUri] = useState(null);
    useEffect(() => {
        const getUri = async (k) => {
            const resp = await getUrl({ path: `public/${k}` });
            setUri(resp.url);
        };

        if (filename) {
            getUri(filename);
        }
    }, [filename]);

    if (!uri) {
        return <></>;
    }
    return <video src={uri} style={style} autoPlay loop controls muted />;
};
